import React from "react";

import "./Blog.css";
import NavLight from "../../components/NavLight";

import BlogPageIntroImg from "../../assets/blog/discovery_interviews_recruit_the_right_users.png";
import BlogsPreview from "../../components/BlogsPreview";
import FoundersGuide from "../../components/FoundersGuide";
import {CustomMetaHelmet} from "../../components/CustomMetaHelmet";
import {meta} from "../../assets/meta/meta";

function HowToDiscoverInterviewsPart1() {
    return (
        <div className="Blog1">
            <CustomMetaHelmet meta={meta['how-to-do-discovery-interviews-find-the-right-customers']}/>
            <NavLight/>
            <section className="blog-page">
                <article className="blog-page-container">
                    <div>
                        <h1>
                            How to do discovery interviews. <br/>
                            Part 1: Recruit the right customers
                        </h1>
                        <p>
                            <i>
                                Conducting customer discovery interviews is one of the quickest
                                ways to validate products and new features. However, recruiting
                                relevant customers to interview can be challenging and
                                time-consuming. In this guide, I will cover how to identify and
                                recruit new customers to interview.
                            </i>
                        </p>
                    </div>
                    <div>
                        <figure>
                            <img
                                src={BlogPageIntroImg}
                                alt="purple hand pressing a digital button"
                            />
                        </figure>
                    </div>
                    <div>
                        <h2>Start with your ideal customer profile (ICP)</h2>
                        <p>
                            While it may seem obvious, it is crucial to identify your target
                            audience before attempting to find them. Therefore, you must begin
                            by clearly defining your ideal customer profile (ICP). It is
                            important to avoid focusing on multiple ICPs, as reaching out to
                            diverse target groups can result in significantly varied feedback
                            that may pull you in conflicting directions.
                        </p>
                    </div>
                    <div>
                        <h2>Map down your ICP’s online behavior</h2>
                        <p>
                            Once you have a clear definition of your ICP, it's time to
                            identify their online behaviors. While many of us visit similar
                            websites online, your ICP is likely to have specific websites and
                            online communities they follow due to personal or professional
                            interests. It is essential to think beyond the obvious choices and
                            conduct thorough research.
                            <p>&nbsp;</p>
                            For instance, you can initiate your research by analyzing the
                            profiles, pages, and groups that your ICP follows on LinkedIn.
                            Additionally, exploring where your ICP may express their opinions
                            online can provide valuable insights. Don't limit your research to
                            conventional sources. You might uncover popular online webinars,
                            courses, GitHub repositories, or subreddits where you can connect
                            with your ICP.
                            <p>&nbsp;</p>
                            As different the business propositions are from each other, as
                            many ICP’s are out there. If you are selling ‘Sustainable weekly
                            meal plan’, your ideal customer probably is interested in cooking
                            and can be found in various Facebook communities or are following
                            specific Instagram influencers. On the other hand if you are
                            selling a B2B product to Product Managers, they would probably be
                            found on Linkedin. It is not only important where your ICP is
                            online, but what is their intent and state of mind while they are
                            there.
                        </p>
                    </div>
                    <div>
                        <h2>Map down your ICP’s offline behavior</h2>
                        <p>
                            Once you have identified their online behaviors, it's time to
                            explore their offline behaviors—where they spend their time in the
                            real world, preferably during working hours or at work-related
                            events. Again, it's important not to limit your research to
                            conventional methods. Although stepping into the real world may
                            push you beyond your comfort zone, meeting people in person can
                            have a significant impact on the trust and relationships you
                            establish through outreach.
                            <p>&nbsp;</p>
                            For instance, if you want to target recruiters, you might discover
                            a major industry event dedicated to recruitment. Consider
                            purchasing a ticket to the event and make an effort to network
                            with as many attendees as possible. Approach different booths and
                            engage in conversations. In most interactions, people will ask
                            about your professional background, allowing you to naturally
                            introduce your startup into the conversation. If they show
                            interest, you can propose a customer discovery interview. While it
                            may be tempting to invest in a booth and other resources, it is
                            advisable to adopt a scrappy approach initially, testing various
                            strategies in a cost-effective manner.
                        </p>
                    </div>
                    <div>
                        <h2>Leverage existing ICP’s</h2>
                        <p>
                            One of the most overlooked methods for obtaining more customer
                            discovery interviews is simply asking your current customers for
                            referrals. If you ensure that the customer discovery experience is
                            enjoyable and engaging for participants, most of them will be more
                            than happy to suggest others in their network whom you can reach
                            out to. You would be surprised by the number of referrals you can
                            acquire through this approach. It is not uncommon for someone to
                            open doors to multiple highly relevant ICPs for you to engage
                            with. However, it is crucial to remember that no one wants to
                            refer you if you do not provide a great interview experience.
                            Therefore, make it worthwhile for them, valuable enough to ensure
                            they feel comfortable introducing you to people in their network.
                            <p>&nbsp;</p>
                            For instance, at the end of the customer discovery interview, you
                            can ask participants if they know anyone within your ICP whom they
                            would recommend you speak with. When reaching out to these
                            referrals, you can mention the person who recommended them,
                            thereby increasing the credibility of your outreach and improving
                            the chances of securing the interview. Additionally, in certain
                            cases, you can kindly ask if they would be willing to introduce
                            you to that person via email. Introductions made through email
                            often yield incredibly high response rates.
                        </p>
                    </div>
                    <div>
                        <h2>Uncover the potential of your personal network</h2>
                        <p>
                            We are all 6 degrees of separation away from the Dalai Lama, or so
                            the research says. Your personal network is your golden nugget. In
                            today’s connected world you for sure know some people, who fall
                            within your ICP. And if you don’t - the people in your network
                            will for sure know. Be humble and be bold at the same time - what
                            is the worst that can happen - you ask for help and no one
                            answers? So what. But I promise you - someone will.
                            <p>&nbsp;</p>
                            When I started to recruit participants for Magic Feedback’s
                            discovery interviews
                        </p>
                    </div>
                    <div>
                        <h2>Balancing number of participants with relevance</h2>
                        <p>
                            The more interviews you do - the better you would become at deeply
                            understanding your ICP. The better you become at understanding
                            your ICP, the better you would become in selecting the most
                            relevant people to talk to. It is a loop. I promise you it will
                            happen.
                            <p>&nbsp;</p>
                            In the beginning I was reaching out to around 20% ideal ICP and
                            the rest were close enough but not good enough. I am at 80% now
                            and this is how I got there.
                        </p>
                    </div>
                </article>
            </section>
            <section className="related-blogs">
                <h1> You might also like</h1>
                <BlogsPreview/>
            </section>
            <section className="FoundersGuide">
                <FoundersGuide/>
            </section>
        </div>
    );
}

export default HowToDiscoverInterviewsPart1;
